var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentIpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4952 12.3002C60.1517 13.0045 60.1517 14.0106 59.589 14.6143L56.4003 18.0352C55.7439 18.6389 54.8998 18.7395 54.2433 18.1358C40.5508 4.65344 19.4492 4.65344 5.7567 18.1358C5.19399 18.7395 4.25615 18.6389 3.59966 18.0352L0.410984 14.6143C-0.151723 14.0106 -0.151723 13.0045 0.504769 12.3002C17.1046 -4.10006 42.8954 -4.10006 59.4952 12.3002ZM30.0469 32.1213C33.3294 32.1213 36.0491 35.0391 36.0491 38.5606C36.0491 42.1828 33.3294 45 30.0469 45C26.6707 45 24.0447 42.1828 24.0447 38.5606C24.0447 35.0391 26.6707 32.1213 30.0469 32.1213ZM48.9914 23.7703C49.6479 24.374 49.6479 25.4807 49.0852 26.0844L45.8027 29.5053C45.24 30.109 44.3959 30.109 43.7394 29.6059C35.8615 22.261 24.1385 22.261 16.2606 29.6059C15.6041 30.109 14.76 30.109 14.1973 29.5053L10.9149 26.0844C10.3521 25.4807 10.3521 24.374 11.0086 23.7703C21.7939 13.5075 38.2061 13.5075 48.9914 23.7703Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentIpo);
export default __webpack_public_path__ + "static/media/current_ipo.255682c4b4609bc5401269429a870098.svg";
export { ForwardRef as ReactComponent };